import PolicyPage from "../components/PolicyPage";
export default function ServicePolicy() { return <PolicyPage namespace="servicepolicy" />; }
